<!--
 * @Description: 请输入当前文件描述
 * @Author: ChangWenBo (649160016@qq.com)
 * @Date: 2021-02-22 14:22:46
 * @LastEditors: ChangWenBo (649160016@qq.com)
 * @LastEditTime: 2021-02-22 14:35:46
 -->
<template>
  <div id="device-mana">
    <div class="radio-box">
      <el-radio-group v-model="radio1" @change="changeTab">
        <el-radio-button label="入库设备"></el-radio-button>
        <el-radio-button label="出库设备"></el-radio-button>
      </el-radio-group>
    </div>
    <router-view />
  </div>
</template>

<script>
// import { createNamespacedHelpers, mapState } from 'vuex'

// const { mapActions } = createNamespacedHelpers('ManaModeStore')

export default {
  name: 'DeviceMana',
  data () {
    return {
      radio1: '入库设备',
      tab: {
        '出库设备': 'outWarehousing',
        '入库设备': 'warehousing',
      },
    }
  },
  computed: {
  },
  created () {
  },
  methods: {
    changeTab (e) {
      console.log(e)
      this.$router.push({ name: this.tab[e] })
    },
  },
}
</script>

<style lang="less" scoped>
#device-mana {
  width: 100%;
  min-height: 790px;
  // padding-top: 20px;
  background-color: #fff;
  border: 1px solid #EBEEF0;
  >div {
    width: 95%;
    margin: 0 auto;
  }
  .radio-box {
    margin-top: 20px;
  }
}
</style>
